<template>
  <div id="leftTabBarItem" @click="goTo">
    <div id="item" :style="activeStyle" @click="open" @mouseover="mouseover" @mouseout="mouseout">
      <div id="icon">
        <slot name="item-icon"></slot>
      </div>
      <div>
        <slot name="item-text"></slot>
      </div>
      <div v-if="!isActive" class="arrow">
        <slot name="item-open"></slot>
      </div>
      <div v-else class="arrow">
        <slot name="item-hidden"></slot>
      </div>
    </div>
    <slot name="item-child" v-if="!isActive"></slot>
  </div>
</template>

<script>
  export default {
    name: "LeftTabBarItem",
    props: {
      url: {
        type: String,
        default: ''
      }
    },
    data(){
      return{
        isActive:true,
        isMouseover:false
      }
    },
    computed:{
      activeStyle(){
        let path = this.$route.path;
        if (this.url==path){
          return {"background-color":"#20a8d8"}
        }
        if (this.isMouseover){
          return {"background-color":"#20a8d8"}
        }
        // return !this.isActive ? {"background-color":"black"} : {};
      }
    },
    methods: {
      open(){
        this.isActive = !this.isActive;
      },
      mouseover(){
        this.isMouseover = true
      },
      mouseout(){
        this.isMouseover = false
      },
      goTo(){
        if (this.url!==''){
          this.$emit("goTo",this.url)
        }
      }
    }
  }
</script>

<style scoped>
  #item{
    height: 40px;
    display: flex;
    flex-direction: row;
    position: relative;
    padding-left: 17px;
    line-height: 40px;
    background-color: #22232b;
  }
  #icon img{
    display: inline-block;
    height: 16px;
    width: 16px;
    vertical-align: middle;
    margin-right: 2px;
  }
  .arrow{
    position: absolute;
    right: 12px;
  }
  .arrow img{
    display: inline-block;
    height: 14px;
    width: 14px;
    vertical-align: middle;
  }
  #item strong{
    display: inline-block;
    color: white;
    font-size: 12px;
    line-height: 1.3125rem;
  }

  #item div{
    display: inline-block;
    color: white;
    font-size: 12px;
    font-weight: 200;
  }

  #leftTabBarItem #leftTabBarItem #item{
    background-color: #2a2c36;
  }
</style>
